import { getToken, isAuthenticated } from '@/utils/auth';
import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const baseUrl: string = (import.meta as any).env?.VITE_REACT_APP_WS_BASE_URL;
const URL = process.env.NODE_ENV === 'production' ? undefined : baseUrl;

const token = isAuthenticated() ? `${getToken()}` : 'internal';

export const socket = io(URL, {
  path: '/ws/socket.io',
  transports: ['polling'],
  auth: { token, session_uuid: '123456' },
  extraHeaders: {
    Authorization: `Bearer ${token}`,
  },
});

// import { Manager } from 'socket.io-client';

// const manager = new Manager('ws://10.1.0.11:8100', {
//   //   reconnectionDelayMax: 10000,
// //   timeout: 5000,

//   query: {
//     // "my-key": "my-value"
//   },
// });

// export const socket = manager.socket('', {
//   auth: { token: 'internal', session_uuid: '123456' },
// });
